import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { ssListItem } from 'app/components/global';
import editDepartmentProceduresDialog from './dialog.editDepartmentProceduresDialog';
import processRecovery from './processRecovery';
import directive from './department-procedures.directive';
import controller from './department-procedures.controller';


export default angular.module('app.components.advisory.bcp.departmentProcedures', [
  constants,
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
  processRecovery,
  editDepartmentProceduresDialog,
  ssListItem,
])
  .directive('bcpDepartmentProcedures', directive)
  .controller('DepartmentProceduresController', controller)
  .name;

console.log('app.components.advisory.bcp.departmentProcedures created');
